import { useDispatch, useSelector } from "react-redux"
import {
    useFetchWithBody,
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, CHALLAN_TYPE, decryptText, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_PAGEACTION_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, getModValue, linksUrl, SALE_PUR_ENTRY_TYPE, URIEncrypt } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    NextUITable,
} from "../../components"
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    useDisclosure,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faEdit,
    faFileInvoice,
    faPlus,
    faReceipt,
    faTrash,
} from "@fortawesome/free-solid-svg-icons"

import {
    COLUMN_ALIGN_TYPE,
    COLUMN_TYPE,
    FOOTER_TYPE,
    ROW_ACTION_BTN_TYPE,
} from "../../components/NextUITable"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useMemo, useRef, useState } from "react"
import { calculateTotal } from "../../Utility/utility"
import { toast } from "react-toastify"
import ConfirmBox from "../../components/ConfirmBox"
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/roughAllotmentEntrySlice.jsx"



const RoughAllotmentMaster = () => {
    let disapatch = useDispatch()
    let navigate = useNavigate()
    const { compCode, isMultipleCompany, yearId, CurrencySetting } = useSelector((state) => state.company)
    let [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")
    const { strdtype, sptype } = useParams()
    const [entryLabel, setEntryLabel] = useState("Rough Allotment")
    const [selBillType, setSelBillType] = useState('O')
    const [selTradeOf, setSelTradeOf] = useState()
    const [selPktType, setSelPktType] = useState()
    const [naviCode, setnaviCode] = useState()

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)
        disapatch(resetDetailParams())
    }, [])

    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.roughAllotmentEntry.fetch,
        queryKey: "Rough Allotment Data List",

    })
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(",")
            }

        })

    }
    useEffect(() => {

        funFilterData();
    }, [])

    const onSuccessDelete = (data) => {
        setItemToDelete("")

        if (data && data.length > 0) {
            if (data[0].ref == 1) {
                toast.error("Stock can't be delete as it locked", {
                    "position": "top-center",
                    "className": "toast-error",
                })
            }
            else {
                toast.success("deleted successfully", {
                    position: "top-center"
                })
                funFilterData(selTradeOf, selPktType);
            }
        }
    }

    const { mutate: FndeleteNote } = usePost(
        {
            url: apiRoute.roughAllotmentEntry.deleteEntry,
            query: "delete-note",
            onSuccessTasks: onSuccessDelete
        }
    )


    let totalWeight = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "R_Carat",
            }),
        [data]
    )


    let totalAmount = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Rate",
            }),
        [data]
    )

    let totalAmountD = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "DRate",
            }),
        [data]
    )


    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "PartyName",
        "Rgh_Code",
        "Rgh_Name",
        "R_Carat",
        "Rate",
        "DRate",
        "R_InwardDate"


    ]
    const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)

    const exportColumns = [

        {
            name: "Party",
            uid: "PartyName",
        },
        {
            name: "Rough No",
            uid: "Rgh_Code",
        },
        {
            name: "Article",
            uid: "Rgh_Name",
        },
        {
            name: "Weight",
            uid: "R_Carat",
            type: COLUMN_TYPE.number,
        },
        {
            name: "Amount",
            uid: "Rate",
            type: COLUMN_TYPE.number,
        },
        {
            name: "Amount $",
            uid: "DRate",
            type: COLUMN_TYPE.number,
        },
        {
            name: "Inward Date",
            uid: "R_InwardDate",
            type: COLUMN_TYPE.date,
        },


    ]

    const [exportCols, setExportCols] = useState(exportColumns)
    let downloadDataFooter = {
        PartyName: "",
        Rgh_Code: "",
        Rgh_Name: "",
        R_Carat: "Total:" + totalWeight,
        Rate: "Total:" + totalAmount,
        DRate: "Total:" + totalAmountD,
        R_InwardDate: ""
    }
    const [exportFooter, setExportFooter] = useState(downloadDataFooter)

    useEffect(() => {
        if (CurrencySetting && CurrencySetting != "") {
            let AmtColumn = ""
            if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS)
                AmtColumn = "DRate"
            else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar)
                AmtColumn = "Rate"
            else
                setInitialColumn(INITIAL_VISIBLE_COLUMNS)

            if (AmtColumn != "") {
                const filterIniCol = initialColumn.filter(ele => ele != AmtColumn)
                const filterExpCol = exportColumns.filter((ele) => ele.uid != AmtColumn)
                //let footerCol = AmtColumn == 'NetAmtD' ? 'Amount$' : 'Amount'
                const filterExpFooter = Object.keys(downloadDataFooter).filter((ele) => ele != AmtColumn)
                setExportCols(filterExpCol)
                setInitialColumn(filterIniCol)
                setExportFooter(filterExpFooter)
            }
        }
    }, [CurrencySetting, data])

    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Party",
            uid: "PartyName",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Rough No",
            uid: "Rgh_Code",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Article",
            uid: "Rgh_Name",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },

        {
            name: "Weight",
            uid: "R_Carat",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalWeight,
            },
        },
        {
            name: "AMOUNT",
            uid: "Rate",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalAmount,
            },
        },
        {
            name: "AMOUNT($)",
            uid: "DRate",
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalAmountD,
            },
        },
        {
            name: "DATE",
            uid: "R_InwardDate",
            type: COLUMN_TYPE.date,
            align: COLUMN_ALIGN_TYPE.center,
            sortable: true,
        },


    ]

    const handleConfirmBox = (data) => {
        if (data) {

            if (itemToDelete != "" && itemToDelete != null && Object.keys(itemToDelete).length > 0) {
                FndeleteNote({
                    data: {
                        rgh_code: itemToDelete.rgh_code,
                        comp_code: itemToDelete.comp_code,
                    }
                })
            }

            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                disapatch(setDetailParams(itemToEdit))
                disapatch(setNewEntryMode(false))

                navigate(linksUrl.roughAllotment.createAllotmentEntry)
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }

    }

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    comp_code: row.CompCode,
                    rough_code: row.Rgh_Code,
                }
                setItemToEdit(obj)
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete({ rgh_code: row.Rgh_Code, comp_code: row.CompCode })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },
    ]

    const handleAddNew = () => {
        disapatch(resetDetailParams())

        navigate(linksUrl.roughAllotment.createAllotmentEntry)

    }

    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }


    return (
        <div>

            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}

            <MainContainer
                pageName={entryLabel}
                info={[]}
                breadcrumbs={["Stock", entryLabel]}
            >

                <div className="" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}
                    >
                        Add New
                    </Button>
                </div>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={initialColumn}
                    data={data}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportCols}
                    downloadDataFooter={exportFooter}
                    downloadFileName={entryLabel + "stock-List"}
                    showAdvanceFilter={false}
                    id="Rgh_Code"
                ></NextUITable>
            </MainContainer>
        </div>
    )
}
export default RoughAllotmentMaster
